import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["select"]
  static values = { postId: String }

  connect() {
    this.syncToChatProjectField()
    this.observer = new MutationObserver(() => this.syncToChatProjectField())
    this.observer.observe(document.body, { childList: true, subtree: true })
  }

  disconnect() {
    if (this.observer) this.observer.disconnect()
  }

  select(event) {
    const option = event.target.closest(".project-option")
    if (!option) return

    const value = option.dataset.value
    this.selectTarget.value = value

    // Update display text
    const label = document.getElementById("menu_project")
    if (label) {
      const name = option.querySelector("span:nth-child(2)")
      label.textContent = name ? name.textContent : "None"
    }

    // Update checkmarks
    this.element.querySelectorAll(".project-option .fa-check").forEach(el => el.remove())
    const check = document.createElement("span")
    check.className = "fas fa-check ml-2 text-color-highlight"
    option.querySelector(".d-flex").appendChild(check)

    // Close dropdown
    const menu = document.getElementById("projectMenu")
    if (menu) {
      menu.classList.add("d-none")
      menu.classList.remove("d-block")
    }

    this.syncToChatProjectField()
    this.saveToPost()
  }

  syncToChatProjectField() {
    if (!this.hasSelectTarget) return

    const hiddenField = document.getElementById("projectField")
    if (hiddenField) {
      hiddenField.value = this.selectTarget.value
    }

    const chatSelect = document.querySelector('[data-project-select-target="select"]')
    if (chatSelect) {
      chatSelect.value = this.selectTarget.value
    }
  }

  saveToPost() {
    if (!this.postIdValue) return

    const token = document.querySelector('meta[name="csrf-token"]')?.content
    fetch(`/posts/${this.postIdValue}/update_project`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": token
      },
      body: JSON.stringify({ project_id: this.selectTarget.value || null })
    })
  }
}
